export const Unit = {
  unidad: 'unidad',
  m: 'm',
  m2: 'm2',
  m3: 'm3',
  hora: 'hora',
}